// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".uni-create-dnd {\n  width: 300px;\n  height: 300px;\n}\n", ""]);
// Exports
module.exports = exports;
